import { render, staticRenderFns } from "./ClassroomDetails.vue?vue&type=template&id=40bf2490&scoped=true"
import script from "./ClassroomDetails.vue?vue&type=script&lang=js"
export * from "./ClassroomDetails.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetails.vue?vue&type=style&index=0&id=40bf2490&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bf2490",
  null
  
)

export default component.exports